var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"backLink",attrs:{"to":{name: 'home'}}},[_c('div',{staticClass:"back"},[_vm._v("← Zurück")])])}
var staticRenderFns = []

export { render, staticRenderFns }